import { gql } from "@urql/svelte";

const editorialContent = gql`
    query query(
        $location: String!
        $type: String!
        $offset: Int
        $limit: Int
        $categoryId: Int
        $ignoredCategories: [Int]
    ) {
        list(
            location: $location
            type: $type
            offset: $offset
            limit: $limit
            categoryId: $categoryId
            ignoredCategories: $ignoredCategories
        ) {
            id
            title
            url
            imageThumbUrl
            categoryName
            categoryId
            categoryUrl
        }
    }
`;

export default editorialContent;
